import { SVGProps } from 'react';

export const IconBottleService = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg viewBox='0 0 24 24' {...props}>
      <path d='M15 11C15 9.895 14.105 9 13 9V4H11V9C9.895 9 9 9.895 9 11V20H15V11Z' fill='currentColor' />
    </svg>
  );
};
